const config = {
    "broker": "1",
    "name": "Arabic",
    "registrationBundle": "arabic",
    "defaultCountryName": "Saudi Arabia",
    "defaultCountryCode": "SA",
    "fxgeoip_code": "AR",
    languageCode: 'ar',
    languageName:'Arabic',
    spokenLanguageCode:'ar',
    direction:'rtl',
    footerDisclaimer:'719',
    brand: 'iforex',
    content_lang : 'ar_sa'
};
module.exports = config;